import { Button } from '@components/Button';
import { Spinner } from '@components/Spinner';
import { Label } from '@components/styled/Label.styled';
import { useDidUpdateEffect } from '@hooks/useDidUpdateEffect';
import React, { useEffect, useState } from 'react';
import * as styled from './styled/SubmitGroup.styled';

export const SubmitGroup: React.FC<{
    addressVerified?: boolean;
    disabled?: boolean;
    label: string;
    onSubmit: React.ReactEventHandler;
    variant?: 'contained' | 'outlined';
    isLoading?: boolean;
}> = ({ addressVerified, disabled, isLoading, label, onSubmit, variant }) => {
    const [success, setSuccess] = useState(false);
    const [showInfo, setShowInfo] = useState(true);
    useEffect(() => {
        if (addressVerified) {
            setShowInfo(false);
            setSuccess(true);
            const timeout = setTimeout(() => {
                setSuccess(false);
            }, 5000);
            return () => clearTimeout(timeout);
        }
    }, [addressVerified]);

    useDidUpdateEffect(() => {
        if (!success) {
            const timeout = setTimeout(() => {
                setShowInfo(true);
            }, 1000);
            return () => clearTimeout(timeout);
        }
    }, [success]);

    return (
        <styled.SubmitGroup>
            {!isLoading && (
                <Button disabled={disabled} onClick={onSubmit} variant={variant}>
                    <Label>{label}</Label>
                </Button>
            )}
            {isLoading && (
                <styled.SpinnerWrapper>
                    <Spinner />
                </styled.SpinnerWrapper>
            )}
            {showInfo && (
                <styled.Info>
                    Processing this information will take between 10-30 seconds
                </styled.Info>
            )}
        </styled.SubmitGroup>
    );
};
